import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button, Alert } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import BotVerification from "../../BotVerification";


const ContactSection = () => {
  const [formData, setFormData] = useState({
      name: "",
      email: "",
      companyName: "",
      contactNumber: "",
      selectLocation: "",
      selectNoOfProducts: "",
      comments: "",
      source:'Website',
      subSource: "",
      utmsource: "",
      utm_campaign: "",
      utm_device: "",
      utmmedium: "",
      utm_term: "",
      utm_network: "",
      utm_content: "",
    });
  
    const [loading, setLoading] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState(null);
  
    useEffect(() => {
      // On load: capture URL and UTM params
      const url = window.location.href;
      const params = new URLSearchParams(window.location.search);
  
      const updatedData = {
        subSource: url,
        utmsource: params.get("utm_source") || "Organic",
        utm_campaign: params.get("utm_campaign") || "Organic",
        utm_device: params.get("utm_device") || "desktop",
        utmmedium: params.get("utm_medium") || "Organic",
        utm_term: params.get("utm_term") || "Organic",
        utm_network: params.get("utm_network") || "Organic",
        utm_content: params.get("utm_content") || "Organic",
      };
  
      setFormData((prev) => ({ ...prev, ...updatedData }));
    }, []);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);

      if (!turnstileToken) {
        alert("Please complete the verification.");
        return;
      }
  
      const googleScriptUrl =
        "https://script.google.com/macros/s/AKfycbz8wlhLNBQgjQJtt0iqubkyIBIoxM-eOVGeMtmPj3CQY5IlzA5LgUuCcHtjprhT1VaH/exec";
  
      const payload = {
        // access_code: "8F18-F3A4-EE3D-7FF4-1FA2-6F9F",
        access_code:"1BEA-BAFF-A9D4-54DC-860C-4B5F",
        name: formData.name,
        email: formData.email,
        phone: formData.contactNumber,
        source : formData.source,
        // additional_col1_select: formData.selectLocation,
        location:formData.selectLocation,
        company_name: formData.companyName,
        enquiry: formData.comments,
        no_of_products: formData.selectNoOfProducts,
        sub_source: formData.subSource,
        utm_source: formData.utmsource,
        utm_campaign: formData.utm_campaign,
        utm_device: formData.utm_device,
        utm_medium: formData.utmmedium,
        utm_term: formData.utm_term,
        utm_network: formData.utm_network,
        utm_content: formData.utm_content,
      };
  
      const formDataToSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSubmit.append(key, value);
      });
  
      const urlEncodedFormData = new URLSearchParams();
  Object.entries(formData).forEach(([key, value]) => {
    urlEncodedFormData.append(key, value);
  });
      
  
      try {
          const [leadApiResText] = await Promise.all([
            // Lead API
            // fetch("https://growtheye.com/leadApiBeta.php", {
            // fetch("https://leadapi.scaledino.com/api/leads/web", {
            fetch("https://leadapi.growtheye.com/api/leads/web",{
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }).then((res) => res.text()),
        
            // Google Script (no-cors mode)
           await fetch(googleScriptUrl, {
              method: "POST",
              mode :"no-cors",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: urlEncodedFormData.toString(),
            })
          ]);
        
          if (leadApiResText.trim() !== "SUCCESSRound Robin Code Started") {
            console.error("Lead API Error:", leadApiResText);
          }
        
          // No googleRes.ok check here — response is opaque
        
          window.location.href =`/thank-you?email=${encodeURIComponent(formData.email)}&name=${encodeURIComponent(formData.name)}`;
        } catch (error) {
          console.error("Submission error:", error);
          alert("There was an error with the form submission.");
        } finally {
          setTurnstileToken(null);
          setLoading(false);
        }
        
      } 
  return (
    <>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6} className="py-1">
            <label htmlFor="name" className="fw-normal fs-18 ms-1">Name:*</label>
              <input
                type="text"
                name="name"
                className="form-control bgContactFormInput px-2 py-3 m-1 border-dark"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
              />
            </Col>
            <Col md={6} className="py-1">
            <label htmlFor="company-name" className="fw-normal fs-18 ms-1">Company Name:*</label>
              <input
                type="text"
                name="companyName"
                className="form-control bgContactFormInput px-2 py-3 m-1 border-dark"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Your Company Name"
                required
                
              />
            </Col>
            <Col md={6} className="py-1">
            <label htmlFor="work-email" className="fw-normal fs-18 ms-1">Work Email:*</label>
              <input
                type="email"
                name="email"
                className="form-control bgContactFormInput px-2 py-3 m-1 border-dark"
                value={formData.email}
                onChange={handleChange}
                placeholder="work-email"
                required

              />
            </Col>
            <Col md={6} className="py-1">
            <label htmlFor="phoneNumber" className="fw-normal fs-18 ms-1 ">Phone Number:*</label>
              <input
                type="text"
                name="contactNumber"
                className="form-control bgContactFormInput px-2 py-3 m-1 border-dark"
                pattern="[6-9]{1}[0-9]{9}"
                title="Enter a valid contact number"
                value={formData.contactNumber}
                onChange={handleChange}
                placeholder="Your Contact Number"
                maxlength="10"
                required
              />
            </Col>
            <Col md={6} className="py-1">
            <label htmlFor="selectLocation" className="fw-normal fs-18 ms-1">Location:*</label>
              <select
                name="selectLocation"
                className="form-control bgContactFormInput px-2 py-3 mx-1 border-dark"
                value={formData.selectLocation}
                onChange={handleChange}
                required
              >
                <option value="" hidden>
                  Select Location
                </option>
                <option value="Hyderabad">Hyderabad</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Gurugram">Gurugram</option>
                <option value="Delhi">Delhi</option>
                <option value="Noida">Noida</option>
                <option value="Other">Other</option>
              </select>
            </Col>
            <Col md={6} className="py-1">
            <label htmlFor="selectNo.ofproducts" className="fw-normal fs-18 ms-1">No.of Products:*</label>
              <select
                name="selectNoOfProducts"
                className="form-control bgContactFormInput px-2 py-3 mx-1 border-dark"
                value={formData.selectNoOfProducts}
                onChange={handleChange}
                required
              >
                <option value="" hidden>
                  No. Of Products
                </option>
                <option value="50-100 products">50-100 Products</option>
                <option value="100-200 products">100- 200 Products</option>
                <option value="200-300 products">200 - 300 Products</option>
                <option value="above500 products">Above 500 Products</option>
              </select>
              {/* <input type="text" name="formName" value={data[0].ContactFormName} className="w-100" hidden/> */}
            </Col>
            <Col md={12} className="py-1">
            <label htmlFor="comment" className="fw-normal fs-18 ms-1 mt-3">Enquiry:*</label>
              <textarea
                type="textarea "
                className="form-control bgContactFormInput px-2 py-3 m-1 border-dark"
                placeholder="Enquiry"
                name="comments"
                value={formData.comments}
                onChange={handleChange}
              />
            </Col>

            {/* <Button
              className="rounded py-2 px-4 ms-3 mt-3 border-0 fs-16 fw-normal w-25 text-center"
              id="btnCTA"
            >
              Submit
            </Button> */}
            <BotVerification onVerify={setTurnstileToken} />
            <Button
            type="submit"
            className=" mx-3 my-3 rounded-pill py-2 px-4 border-0 fs-16"
              id="btnSubmit"
              disabled={loading}>
            {loading ? "Submitting..." : "Submit"}{" "}
              <Icon
              icon="tabler:circle-arrow-up-right-filled"
              width="24"
              height="24"
              style={{ color: "#fff" }}/>
              </Button>
          </Row>
        </Form>


      
    </>
  );
};

export default ContactSection;
